import {
  GPSTRACKING_FETCHING,
  GPSTRACKING_SUCCESS,
  GPSTRACKING_FAILED,
} from "./types";
import SiteService from "../services/site.service";

export const startGpsTracking = () => (dispatch, getState) => {
  dispatch({ type: GPSTRACKING_FETCHING });

  const updateLocation = async () => {
    if (!("geolocation" in navigator)) {
      dispatch({
        type: GPSTRACKING_FAILED,
        payload: { code: 0, message: "Geolocation not supported" },
      });
      return;
    }

    navigator.geolocation.getCurrentPosition(
      async (position) => {
        const coordinates = {
          lat: position.coords.latitude,
          lng: position.coords.longitude,
        };

        dispatch({ type: GPSTRACKING_SUCCESS, payload: coordinates });

        const state = getState();
        const user = state.auth?.user;

        if (!user || !user.idUser) {
          console.error("User not authenticated or missing idUser");
          return;
        }

        try {
          let existingRecord = null;
          try {
            existingRecord = await SiteService.getLocationDriverById(user.idUser);
          } catch (error) {
            if (error.response && error.response.status === 404) {
              existingRecord = null;
            } else {
              console.error("Error fetching location driver:", error);
              return;
            }
          }

          if (existingRecord) {
            await SiteService.setLocationDriver({
              idDriver: user.idUser,
              lat: coordinates.lat,
              lng: coordinates.lng,
              lastUpdate: new Date().toISOString(),
            });
          } else {
            await SiteService.addLocationDriver({
              idDriver: user.idUser,
              lat: coordinates.lat,
              lng: coordinates.lng,
              lastUpdate: new Date().toISOString(),
            });
          }
        } catch (error) {
          console.error("Error updating location driver table:", error);
        }
      },
      (error) => {
        dispatch({
          type: GPSTRACKING_FAILED,
          payload: { code: error.code, message: error.message },
        });
      }
    );
  };

  updateLocation();

  const interval = setInterval(updateLocation, 60000);

  return () => clearInterval(interval);
};

// import {
//   GPSTRACKING_FETCHING,
//   GPSTRACKING_SUCCESS,
//   GPSTRACKING_FAILED,
// } from "./types";
// import SiteService from "../services/site.service";

// export const startGpsTracking = () => (dispatch, getState) => {
//   dispatch({ type: GPSTRACKING_FETCHING });

//   const updateLocation = () => {
//     if (!("geolocation" in navigator)) {
//       dispatch({
//         type: GPSTRACKING_FAILED,
//         payload: { code: 0, message: "Geolocation not supported" },
//       });
//       return;
//     }

//     navigator.geolocation.getCurrentPosition(
//       (position) => {
//         const coordinates = {
//           lat: position.coords.latitude,
//           lng: position.coords.longitude,
//         };

//         dispatch({ type: GPSTRACKING_SUCCESS, payload: coordinates });

//         const state = getState();
//         const deliverySampleLocationDriver = state.deliverySampleLocationDriver;

//         if (
//           deliverySampleLocationDriver.result &&
//           deliverySampleLocationDriver.result.length > 0 &&
//           !deliverySampleLocationDriver.result[0].endTime
//         ) {
//           SiteService.setDeliverySampleLocationDriverByIdUsage({
//             idUsage: deliverySampleLocationDriver.result[0].idUsage,
//             Lat: coordinates.lat,
//             Lng: coordinates.lng,
//             endTime: "",
//             lastUpdate: new Date().toISOString(),
//           });
//         }
//       },
//       (error) => {
//         dispatch({
//           type: GPSTRACKING_FAILED,
//           payload: { code: error.code, message: error.message },
//         });
//       }
//     );
//   };

//   updateLocation();

//   const interval = setInterval(updateLocation, 60000);

//   return () => clearInterval(interval);
// };
